import Vue from 'vue';
import { isBrowser } from '../shareds';
import CsToast from './CsToast.vue';

const TOAST_PORTAL_ID = 'cs-toast-teleport-target';
const TOAST_ROOT_ID = 'cs-toast-root';
const VM = typeof window !== 'undefined' && window.Vue ? window.Vue : Vue;

function createToastPortal() {
  if (!isBrowser) return;

  let portalElement;
  const existingPortalElement = document.getElementById(TOAST_PORTAL_ID);

  if (existingPortalElement) {
    portalElement = existingPortalElement;
  } else {
    const el = document.createElement('div');
    el.id = TOAST_PORTAL_ID;
    if (document.body != null) {
      document.body.appendChild(el);
    }
    portalElement = el;
  }

  const root = document.createElement('div');
  root.id = TOAST_ROOT_ID;
  portalElement.appendChild(root);
}

function createToastInstance() {
  if (!isBrowser) return;

  Vue.nextTick(() => {
    new VM({
      name: 'CommslayerToast',
      render: h => h(CsToast),
    }).$mount(`#${TOAST_ROOT_ID}`);
  });
}

// Initialize toast system - ensure both functions are called once and in order
let initialized = false;
export function initializeToastInstance() {
  if (initialized || !isBrowser) return;

  createToastPortal();
  createToastInstance();

  initialized = true;
}
